import { useContext } from 'react'
import ConfigContext from './ConfigProvider.context'

export const useConfig = () => {
  const { regionInfo, userUnitsInfo } = useContext(ConfigContext)

  return { regionInfo, userUnitsInfo }
}
